import Headings from 'admin/components/atoms/Headings';
import BreadCrumb from 'admin/components/molecules/BreadCrumb';
import ButtonGroup from 'admin/components/molecules/ButtonGroup';
import CreateCampaign from 'admin/components/pages/CreateCampaign';
import React, { useState } from 'react';
import styled from 'styled-components';
import CreateMoneyAccountHook from './CreateMoneyAccountHook';

const FormWrapper = styled.div``;

const SettingsCampaigns = () => {
  const crumbs = [
    { value: 'ホーム', href: '/', isCurrentPage: false },
    { value: 'サービス管理', href: '', isCurrentPage: true },
    { value: 'キャンペーン登録', href: '', isCurrentPage: true },
  ];
  const buttonProps = [
    { text: '取引時ポイント還元', value: 'campaign', is_active: true },
    { text: 'ウォレット追加時ポイント還元', value: 'moneyAccountHook', is_active: false },
  ];
  const [buttons, setButtons] = useState(buttonProps);
  const [selectedButton, setSelectedButton] = useState(buttonProps[0]);

  const onButtonGroupClick = (btn, index) => {
    setButtons(buttons.map((b, i) => Object.assign({}, b, { is_active: i == index })));
    setSelectedButton(buttons[index]);
  };

  return (
    <FormWrapper>
      <BreadCrumb crumbs={crumbs} />
      <Headings.h5>キャンペーン登録</Headings.h5>
      <ButtonGroup buttons={buttons} onClick={onButtonGroupClick} />
      {selectedButton.value === 'campaign' ? <CreateCampaign /> : null}
      {selectedButton.value === 'moneyAccountHook' ? <CreateMoneyAccountHook /> : null}
    </FormWrapper>
  );
};

export default SettingsCampaigns;
